import { Box, Typography, useTheme, Divider } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format_Number } from '../../utils/utils';

const PaymentCard = ({ Css }) => {
  const theme = useTheme();
  const {
    totalPrice,
    upsaleProductPrice,
    totalVAT,
    selectedUpsaleProducts,
    quantities,
    languageWords,
    selectedTreatmentType,
    transactionDetails,
  } = useSelector((store) => store?.salon);

  function calculateVatForProducts(price, percentage) {
    return (price * percentage) / 100;
  }

  const VAT_PERCENT_PRODUCTS = calculateVatForProducts(
    selectedTreatmentType?.price,
    21
  );
  const VAT_TOTAL_PRODUCTS =
    selectedTreatmentType?.price -
    selectedTreatmentType?.price / (1 + VAT_PERCENT_PRODUCTS / 100);

  const VAT_TOTAL_EXTRA =
    selectedUpsaleProducts?.reduce((acc, product) => {
      return (
        (acc +
          product?.price -
          product?.price / (1 + product?.vat / 100)) *
        product.quantity
      );
    }, 0) || 0;

  const VAT_TOTAL_TRANSACTION_COST =
    transactionDetails?.pricePerReservation > 0
      ? (transactionDetails?.pricePerReservation -
          transactionDetails?.pricePerReservation /
            (1 + transactionDetails?.vat / 100)) *
        1
      : 0;

  const TOTAL_VAT = (
    VAT_TOTAL_PRODUCTS +
    VAT_TOTAL_EXTRA +
    VAT_TOTAL_TRANSACTION_COST
  ).toFixed(2);

  const TOTALPRICE =
    (totalPrice > 0 && transactionDetails?.pricePerReservation > 0
      ? totalPrice + transactionDetails?.pricePerReservation
      : totalPrice) + upsaleProductPrice;

  const TOTALINCLUSIVE = TOTALPRICE;

  /** Reusable row — label wraps, price never breaks */
  const PriceRow = ({ label, value, bold = false }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        gap: 1,
        mb: 0.6,
      }}
    >
      <Typography
        sx={{
          color: Css?.salonCardSectionInfoClr,
          fontSize: "14px",
          fontWeight: bold ? 600 : 400,
          flex: "1 1 0",
          minWidth: 0,
          wordBreak: "break-word",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: Css?.salonCardSectionPriceClr,
          fontSize: "14px",
          fontWeight: bold ? 600 : 400,
          flexShrink: 0,
          whiteSpace: "nowrap",
          mr:3
        }}
      >
        {value}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: Css?.salonCardSectionBgClr,
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        p: 2,
        mt: 2,
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <Typography
        sx={{
          color: Css?.salonCardSectionHeadingClr,
          fontWeight: "600",
          fontSize: { md: "16px", sm: "20px", xs: "18px" },
          mb: 2,
        }}
      >
        {languageWords?.Payment}
      </Typography>

      {totalPrice + upsaleProductPrice > 0 &&
        !isNaN(totalPrice + upsaleProductPrice) && (
          <>
            <Divider sx={{ mb: 1 }} />

            {transactionDetails?.pricePerReservation > 0 && (
              <PriceRow
                label={transactionDetails?.languages[0]?.data}
                value={`€${format_Number(
                  parseFloat(transactionDetails?.pricePerReservation).toFixed(2)
                )}`}
              />
            )}

            <PriceRow
              label={languageWords["excludingVAT"]}
              value={`€${format_Number(
                parseFloat(TOTALPRICE - TOTAL_VAT).toFixed(2)
              )}`}
            />
          </>
        )}

      {TOTAL_VAT > 0 && (
        <PriceRow
          label={languageWords?.VAT}
          value={`€${format_Number(parseFloat(TOTAL_VAT).toFixed(2))}`}
        />
      )}

      {TOTALINCLUSIVE > 0 && !isNaN(totalPrice + upsaleProductPrice) && (
        <>
          <Divider sx={{ mt: 0.5, mb: 1 }} />
          <PriceRow
            label={languageWords["TotalIncludingVAT"]}
            value={`€${format_Number(parseFloat(TOTALINCLUSIVE).toFixed(2))}`}
            bold
          />
        </>
      )}
    </Box>
  );
};

export default PaymentCard;
